exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".button-group {\n  display: flex;\n  flex-direction: column; }\n  .button-group--left {\n    justify-content: flex-start; }\n  .button-group--right {\n    justify-content: flex-end; }\n\n:host /deep/ .button-group--full bb-button, :host /deep/ .button-group--full .button {\n  width: 100%; }\n\n:host /deep/ bb-button:not(:first-child) {\n  margin-top: 5px; }\n\n@media only screen and (min-width: 768px) {\n  .button-group {\n    flex-direction: row; }\n  :host /deep/ bb-button:not(:first-child) {\n    margin-top: 0;\n    margin-left: 5px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/button-group/button-group.component.scss
// module id = 46
// module chunks = 0 1